import React from "react";
import { Helmet } from "react-helmet-async";
const SchemaComponent = () => {
  const schemaData = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: "All On Four Dental Implants",
    image: "",
    description:
      "Full arch implant dentistry (often referred to as all-on-four dental implants or all-on-six dental implants) is a cutting-edge solution for patients who need to replace an entire arch of teeth. Up to six dental implants anchor a custom-designed prosthetic, to restore both the function and aesthetics of a full set of teeth, providing a natural-looking and permanent alternative to traditional dentures.",
  };
  const schemaData2 = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      name: "Is the procedure actually completed in one day?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "This is one of the main advantages of the All on 4 dental implants. When you imagine having to replace multiple teeth it sounds as though it could be a long, painstaking process with multiple trips to the dentist. Thankfully, due to the angle of placement of All on 4, the implants can support a temporary bridge from day one for most patients! After approximately 4 months, we will replace your temporary bridge with a permanent one over a few visits."
      }
    },{
      "@type": "Question",
      name: "How are full arch implants different from traditional dentures?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Unlike traditional dentures, full arch implants are permanently anchored to the jawbone, offering greater stability, chewing power, and a more natural look and feel. They don’t slip or need adhesives, and they help prevent bone loss in the jaw."
      }
    },{
      "@type": "Question",
      name: "How long do full arch implants last?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "With proper care, full arch implants can last 20 years or longer. Regular dental check-ups, good oral hygiene, and a healthy lifestyle all contribute to the longevity of implants."
      }
    },{
      "@type": "Question",
      name: "Are there any risks or complications?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "As with any surgery, there are risks such as infection, implant failure, or nerve damage, though these are rare. Choosing an experienced implant dentist and following aftercare instructions can reduce risks."
      }
    },{
      "@type": "Question",
      name: "I have gum disease, can I have implants?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, periodontal patients can have dental implants. However, it is important the gum disease affecting your remaining natural teeth is adequately treated before implant placement. It is also important to note that the risk of complications related to implant treatment seems to be somewhat higher in periodontal patients, but with regular maintenance, it is not a contraindication."
      }
    },{
      "@type": "Question",
      name: "Can dental implants be done in a single day?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, dental implants can sometimes be done in a single day, a procedure known as “same-day dental implants” or “teeth in a day.” This approach allows for the placement of the implant and a temporary crown or bridge in a single visit. However, not all patients are suitable candidates for this procedure. Some Factors That Determine Eligibility: Bone Density & Health – Adequate bone structure is needed to support the implant. Oral Health – Healthy gums and no active infections or gum disease are essential. Overall Health – Conditions like diabetes or smoking habits may affect healing."
      }
    },{
      "@type": "Question",
      name: "What is the difference between full arch implants and traditional dentures?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "The main difference between full arch implants and traditional dentures is how they are supported and secured in the mouth. Full mouth implants are anchored to the jawbone using 4-6 dental implants usually. They are very secure and do no not slip or move like dentures. Full arch implants feel more like natural teeth and there is no need for adhesives unlike dentures. Further, implants help preserve jawbone by preventing bone loss whereas dentures do not do this, which can lead to changes in facial structure. Full arch implants are the better option for long-term oral health, comfort and function."
      }
    },{
      "@type": "Question",
      name: "What is the average lifespan of dental implants?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Implants have high success rates and there are reports that have assessed their performance over a period of more than 25 years. The most recent studies indicate that 90% of implants placed ten years ago are still functional today. The long-term success of implants also depends greatly on how well they are cleaned and maintained. In most cases, as a minimum, an annual check-up and regular hygienist visits are recommended so the implants can be professionally cleaned. Moreover, brushing and flossing at home is of paramount importance."
      }
    },{
      "@type": "Question",
      name: "How should I maintain and clean my full arch implants?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Cleaning full arch implants is crucial to maintaining oral health and preventing complications like gum disease around implants. Caring for implants includes brushing twice a day, flossing, using an antibacterial mouthwash, and regular dental check-ups. We also recommend specific tools, like a water flosser, to clean around the implants. An annual check-up and regular hygienist visits are recommended so the implants can be professionally cleaned."
      }
    },{
      "@type": "Question",
      name: "Who is suitable for All on 4 dental implants?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "All on 4 Same Day Teeth are perfect for patients who have very few of their own teeth remaining (which may be failing) and would like a more secure, permanent solution to dentures. They are also ideal for patients who have suffered bone loss in the jaw area, making single tooth implants unsuitable because of the reduced bone density. The All on 4 implants use the natural thicker bone towards the front of the jaw, meaning that patients can often receive a full new arch of teeth without having to undergo graft surgery."
      }
    },{
      "@type": "Question",
      name: "How long do implants last?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Implants have high success rates and there are reports that have assessed their performance over a period of more than 25 years. The most recent studies indicate that 90% of implants placed ten years ago are still functional today. The long-term success of implants also depends greatly on how well they are cleaned and maintained. In most cases, as a minimum, an annual check-up and regular hygienist visits are recommended so the implants can be professionally cleaned. Moreover, brushing and flossing at home is of paramount importance."
      }
    },{
      "@type": "Question",
      name: "How should I care for my full arch implants?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Caring for implants includes brushing twice a day, flossing, using an antibacterial mouthwash, and regular dental check-ups. Dentists may recommend specific tools, like a water flosser, to clean around the implants."
      }
    },{
      "@type": "Question",
      name: "I’m a really nervous patient, what are my options?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Is dental fear and phobia preventing you from having your perfect smile with dental implants? We understand that a visit to the dentist can be quite challenging. We believe everybody deserves a smile that is healthy and happy and we are committed to working with you to help get treatment. That’s why we have adopted a relaxed and informal approach that helps put our patients at ease. Moreover, we offer dental sedation to ensure you never skip your next dental appointment again. Dr Nadeem Sabir provides patients treatment with Intravenous Sedation, which involves the controlled delivery of a sedative drug, which quickly induces feelings of deep relaxation and peace. Further, this leaves you with little or no recollection of the procedure. Intravenous sedation is not like a general anaesthetic, in that you do not lose consciousness. We have been able to help many patients finally overcome dental anxiety by providing them the dental treatment they need using a relaxed and calming approach."
      }
    },{
      "@type": "Question",
      name: "Will my speech be affected by full arch implants?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Full arch implants can affect your speech, especially in the initial adjustment period. However, most people adapt quickly, and speech typically improves over time. Most patients find that their speech returns to normal or even improves as they get used to their implants."
      }
    },{
      "@type": "Question",
      name: "Will I experience pain during or after the implant procedure?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "During the dental implant procedure, you shouldn’t feel any pain because wea will use a local anaesthetic to numb the area. You may feel some pressure or mild discomfort, but it shouldn’t be painful. We also provide intravenous sedation for patients who are anxious. After the procedure, it’s normal to experience some soreness, swelling, and mild discomfort for a few days. This is usually manageable with over-the-counter pain relievers like ibuprofen or paracetamol. Most people find the discomfort improves significantly within a 24-48 hours."
      }
    },{
      "@type": "Question",
      name: "How soon can I eat normally after getting implants?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "You can typically eat a few hours after your dental implant procedure. However, you should stick to soft foods and liquidsfor at least the first 24 to 48 hours to avoid disturbing the surgical site and avoid anything to hot."
      }
    },{
      "@type": "Question",
      name: "What is the average lifespan of dental implants?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Implants have high success rates and there are reports that have assessed their performance over a period of more than 25 years. The most recent studies indicate that 90% of implants placed ten years ago are still functional today. The long-term success of implants also depends greatly on how well they are cleaned and maintained. In most cases, as a minimum, an annual check-up and regular hygienist visits are recommended so the implants can be professionally cleaned. Moreover, brushing and flossing at home is of paramount importance."
      }
    }]
  }
  
  const schemaData3 = { 
    "@context": "https://schema.org", 
    "@type": "WebSite", 
    "@id": "https://www.samedaysmile-ilkley.com/#organization", 
    headline: "Same Day Smile Full Arch Implant Dentistry in Ilkley West Yorkshire", 
    url: "https://www.samedaysmile-ilkley.com/", 
    name: "Same Day Smile ilkley", 
    description: "Local Dentist in Kington Herefordshire - “ this part of it will be replaced with “Local Dentist in Ilkley, West Yorkshire", 
    inLanguage: "en-UK", 
    author: { "@id": "https://www.samedaysmile-ilkley.com/#organization" }, 
    creator: { "@id": "https://www.samedaysmile-ilkley.com/#organization" }, 
    publisher: { "@id": "https://www.samedaysmile-ilkley.com/#organization" }, 
    provider: { "@id": "https://www.samedaysmile-ilkley.com/#organization" }, 
    mentions: [ "https://en.wikipedia.org/wiki/Full_arch_restoration", "Arch Implants" ] 
  };
  const schemaData4 = {
    "@context": "https://schema.org/",
    "@type": "LocalBusiness",
    name: "Same Day Smile ilkley",
    url: "https://www.samedaysmile-ilkley.com/",
    sameAs: [
      "https://www.instagram.com/regentdental_ilkley/"
      ],
    address: {
      "@type": "PostalAddress",
      "streetAddress": "2A Regent Rd",
      "addressLocality": "Ilkley",
      "postalCode": "LS29 9EA",
      "addressCountry": "UK"
    },
   telephone: "+44 1943 661331",
    openingHours: "Mo-saturday 09:00-17:00",
    image: "https://www.samedaysmile-ilkley.com/static/media/header-logo.d5abac7d7e76717023d1.png" 
  }
   
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData2)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData3)}</script>
      <script type="application/ld+json">{JSON.stringify(schemaData4)}</script>
    </Helmet>
  );
};

export default SchemaComponent;
